<div class="modal-header">
  <h5 class="modal-title text-center" style="width: 100%;" id="modal-title">
    MTO-FSOL-07 Sustancias
    <p class="lead" style="margin: 0;">
      <strong>{{ code }}</strong>
    </p>
  </h5>
  <button
    type="button"
    class="close"
    aria-label="Close button"
    aria-describedby="modal-title"
    [disabled]="loading || save || saving"
    (click)="modal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">  
  <div class="row" *ngIf="currentForm">
    <div class="col-lg-12">
      <form-builder [formData]="currentForm"></form-builder>
    </div>
  </div>

  <div class="row" *ngIf="!currentForm">
    <div class="col-lg-12 d-flex justify-content-center">
      <span class="spinner-border spinner-border-lg align-center" style="margin-top: 10%; margin-bottom: 10%;"></span>
    </div>
  </div>

  <div *ngIf="saving" style="width: 100vw; height: 100vh; background-color: #00000055; position: fixed; top: 0; left: 0; z-index: 100000;">
    <div  style="position: fixed; right: 20px; bottom: 20px; background-color: #FFFFFF; padding: 10px; border-radius: 5px;">
      <span class="text-dark" style="margin-right: 10px;">{{percentage != 0 ? 'Subiendo archivos: ' : 'Guardando'}}<span *ngIf="percentage != 0">{{percentage}}%</span></span>
      <span class="spinner-border spinner-border-sm align-center text-success" ></span>
    </div>
  </div>

  <div *ngIf="save" style="width: 100vw; height: 100vh; background-color: #00000055; position: fixed; top: 0; left: 0; z-index: 99999;">
    <div  style="position: fixed; right: 20px; bottom: 20px; background-color: #FFFFFF; padding: 10px; border-radius: 5px;">
      <span class="text-dark" style="margin-right: 10px;">Guardando sustancia</span>
      <span class="spinner-border spinner-border-sm align-center text-success" ></span>
    </div>
  </div>
</div>

<div class="modal-footer justify-content-center" style="margin-top: 50px">
  <button
    type="button"
    class="btn btn-outline-secondary"
    [disabled]="loading || save || saving"
    (click)="modal.close('cancel click')"
  >
    Cerrar
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="loading || save || saving"
    (click)="onlySave()"
  >
    <span
      *ngIf="save || saving"
      class="spinner-border spinner-border-sm mr-1"
    ></span>
    Guardar y salir
  </button>
  <button
    type="button"
    class="btn btn-success"
    [disabled]="loading || save || saving"
    (click)="goBack()"
  >
    <span
      *ngIf="save || saving"
      class="spinner-border spinner-border-sm mr-1"
    ></span>
    Finalizar revisión
  </button>
</div>
